// extracted by mini-css-extract-plugin
export var productImage = "_qc-1";
export var viewLink = "_qc-2";
export var wishlistItem = "_qc-0";